import { Initializer } from 'common/types/initializers';
import React from 'react';
import ReactDOM from 'react-dom';
import { Reconnect } from 'federation/Reconnect';
import type {
  NoShowV2ConfirmationModalProps,
  NoShowV2ConfirmResult,
} from 'reconnect-types/moduleFederation';

export const NoShowV2ConfirmationModalInitializer = ({
  onClose,
  onConfirm,
  ...otherProps
}: NoShowV2ConfirmationModalProps): Initializer => {
  const container = document.createElement('div');
  document.body.appendChild(container);

  const destroy = () => {
    ReactDOM.unmountComponentAtNode(container);
    container.remove();
  };

  const render = () => {
    ReactDOM.render(
      <Reconnect
        name="NoShowV2ConfirmationModal"
        props={{
          onClose: () => {
            onClose?.();
            destroy();
          },
          onConfirm: (result: NoShowV2ConfirmResult) => {
            onConfirm?.(result);
            destroy();
          },
          ...otherProps,
        }}
      />,
      container,
    );
  };

  return { destroy, render };
};
